"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serial = void 0;
// Execute promises in serial.
const serial = (proms) => proms.reduce((memo, prom) => memo.then((vals) => prom().then((val) => vals.concat(val))), Promise.resolve([]));
exports.serial = serial;
